import React from 'react'
import Spain from './spain'
import CanaryIsland from './canary-island'
import Ceuta from './ceuta'
import Melilla from './melilla'
import useStyles from './styles'

const Map = props => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Spain
        className={classes.spain}
        checkedProvinces={props.checkedProvinces}
      />
      <CanaryIsland
        className={classes.canaryIsland}
        checkedProvinces={props.checkedProvinces}
      />
      <Ceuta
        className={classes.ceuta}
        checkedProvinces={props.checkedProvinces}
      />
      <Melilla
        className={classes.melilla}
        checkedProvinces={props.checkedProvinces}
      />
    </div>
  )
}

export default Map
